import { useCallback } from 'react'
import {
  ApiGetNoToken,
	useFetch
} from 'shared/api'
import {
	prefectureApi
} from 'interface/endpoints'
import {
	BlockResultList,
	PrefectureResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListBlock = (
) => useFetch(
	useCallback(
		(cancelToken) => {
      return ApiGetNoToken<BlockResultList>(
				prefectureApi('/block/list', { t }),
				cancelToken
			)
    },
		[]
	)
)

export const useListPrefecture = (
	blockCode: string | undefined | null
) => useFetch(
	useCallback(
		(cancelToken) => {
      return ApiGetNoToken<PrefectureResultList>(
				prefectureApi((blockCode !== 'all' && blockCode) ? `/${blockCode}/list` : '/list', { t }),
				cancelToken
			)
    },
		[blockCode]
	)
)
